class LocationNavigation extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.querySelector('input')?.addEventListener('input', this.filter, { signal: this.controller.signal });
    this.querySelector('[data-clear-locations]')?.addEventListener('click', () => {
      const input = this.querySelector('input');
      if (!input) return;
      input.value = '';
      this.filter({ target: input });
      input.focus();
    }, { signal: this.controller.signal });
    const restoreSearch = () => {
      const input = this.querySelector('input');
      if (input) this.filter({ target: input });
    };
    window.addEventListener('pageshow', restoreSearch, { signal: this.controller.signal });
    // The header-row index is a panel over the photographs: it fades and slides in and out, and
    // closes on a click elsewhere or Escape. data-animated turns the CSS transition on only once
    // this script runs, so the panel still opens without it.
    const dropdown = this.querySelector('details[data-location-dropdown]');
    if (dropdown) {
      const summary = dropdown.querySelector?.('summary');
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      const frame = window.requestAnimationFrame?.bind(window) ?? ((callback) => setTimeout(callback, 16));
      dropdown.setAttribute?.('data-animated', '');
      if (dropdown.open) dropdown.classList?.add('is-shown');
      const show = () => {
        clearTimeout(this.closeTimer);
        dropdown.open = true;
        frame(() => frame(() => dropdown.classList?.add('is-shown')));
      };
      const hide = () => {
        if (!dropdown.open) return;
        dropdown.classList?.remove('is-shown');
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          if (!dropdown.classList?.contains('is-shown')) dropdown.open = false;
        }, reduceMotion ? 0 : 200);
      };
      summary?.addEventListener('click', (event) => {
        event.preventDefault();
        if (dropdown.open && dropdown.classList?.contains('is-shown')) hide();
        else show();
      }, { signal: this.controller.signal });
      window.addEventListener('click', (event) => {
        if (dropdown.open && !dropdown.contains(event.target)) hide();
      }, { signal: this.controller.signal });
      dropdown.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !dropdown.open) return;
        hide();
        summary?.focus();
      }, { signal: this.controller.signal });
    }
    restoreSearch();
  }
  disconnectedCallback() { this.controller?.abort(); }
  filter = (event) => {
    const query = event.target.value.trim().toLocaleLowerCase();
    const list = this.querySelector('details[data-location-list]');
    const shortcuts = this.querySelector('[data-location-shortcuts]');
    if (list !== this.searchList) {
      this.searchList = list;
      this.searching = false;
    }
    if (list) {
      if (query) {
        if (!this.searching) {
          this.listWasOpen = list.open;
          this.shortcutsWereHidden = shortcuts?.hidden ?? false;
          this.searching = true;
        }
        list.open = true;
        if (shortcuts) shortcuts.hidden = true;
      } else if (this.searching) {
        list.open = this.listWasOpen;
        if (shortcuts) shortcuts.hidden = this.shortcutsWereHidden;
        this.searching = false;
      }
    }
    let matches = 0;
    for (const item of this.querySelectorAll('.cp-location-navigation__links li')) {
      // Match the start of any word, so 'harl' finds Harlyn but not Charlestown.
      const words = item.textContent.trim().toLocaleLowerCase();
      item.hidden = Boolean(query) && !(words.startsWith(query) || words.includes(' ' + query));
      if (!item.hidden) matches++;
    }
    for (const group of this.querySelectorAll('[data-location-group]')) {
      group.hidden = ![...group.querySelectorAll('li')].some((item) => !item.hidden);
    }
    const empty = this.querySelector('[data-no-locations]');
    if (empty) empty.hidden = matches > 0;
  };
}
if (!customElements.get('location-navigation')) customElements.define('location-navigation', LocationNavigation);
